import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import { useCustomToast } from 'hooks';
import { fiscalizationF1 } from 'modules/_common/api';

export const useMutationFiscalizationF1 = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(fiscalizationF1, {
    onSuccess: () => successToast(t('Fiscalization 1.0 successfully completed')),
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
